module.exports = __webpack_public_path__ + "static/media/banner-2.8502cc8e.png";